module.exports = __webpack_public_path__ + "media/images/stripe/wordmark-5bb064ffb6ba85227a50e07196f9b98d.png";